const eventMapping = {
  facebook: {
    click_register: null,
    click_OTP_verify: null,
    click_binding_bank: null,
    click_free_credit: null,
    click_promo_code: null,
    sign_up_success: 'CompleteRegistration',
    OTP_verification_success: null,
    bank_verification_success: 'AddPaymentInfo',
    login_success: null,
    click_deposit: null,
    submit_deposit: 'InitiateCheckout',
    purchase: 'Purchase',
    activity_click: 'ViewContent',
    activity_detail: 'ViewContent',
    game_click: null,
    lobby_click: null,
    open_page: 'ViewContent',
    close_page: null,
    page_view: 'ViewContent',
    search: 'SEARCH',
  },
  kwai: {
    click_register: 'buttonClick',
    click_OTP_verify: 'buttonClick',
    click_binding_bank: 'buttonClick',
    click_free_credit: 'buttonClick',
    click_promo_code: 'buttonClick',
    sign_up_success: 'completeRegistration',
    OTP_verification_success: null,
    bank_verification_success: 'addPaymentInfo',
    login_success: null,
    click_deposit: 'buttonClick',
    submit_deposit: 'initiateCheckout',
    purchase: 'purchase',
    activity_click: 'contentView',
    activity_detail: 'contentView',
    game_click: 'buttonClick',
    lobby_click: 'buttonClick',
    open_page: 'contentView',
    close_page: null,
    page_view: 'contentView',
    search: 'SEARCH',
  },
}
export function convertEventName(event, tracker) {
  let eventName = eventMapping[tracker] ? (eventMapping[tracker][event] ? eventMapping[tracker][event] : event) : event
  return eventName
}
